import type { ReactNode } from 'react';
import { Card, Stack } from '@mantine/core';

/**
 * ViewPanel — контейнер для блоков информации в entity view (PartnerView, DealView, LeadView).
 * Задаёт общий внешний вид: padding, shadow, позиционирование.
 * Не содержит бизнес-логики — только layout и визуал.
 *
 * Включает стиль `.entity-view-placeholder-dimmed` для плейсхолдеров «Добавить …»:
 * серый цвет, курсив. Использовать на EditableText при пустом значении.
 */
export function ViewPanel({ children }: { children?: ReactNode }) {
  return (
    <Card padding='xs' shadow='none'>
      <style>{`
        .entity-view-placeholder-dimmed:not(input):not(textarea) {
          color: var(--mantine-color-gray-5) !important;
          font-style: italic !important;
        }
        .entity-view-placeholder-dimmed::placeholder {
          color: var(--mantine-color-gray-5) !important;
          font-style: italic !important;
        }
      `}</style>
      <Stack gap='xs'>{children}</Stack>
    </Card>
  );
}
